
import CollectionBox from '@/components/CollectionBox'
import TitleBox from '@/components/CSS/TitleBox'

export default {
    components: {
        CollectionBox,
        TitleBox,
    },
    data() {
        return {
            managementStatus: false,
            selectedCount: 0
        }
    },
    methods: {
        getSelectedCount(v) {
            this.selectedCount = v
        },
        changeStatus() {
            this.managementStatus = !this.managementStatus
            if (!this.managementStatus) this.$refs.CollectionBoxRef.clearCheckedChange()
        },
        cannelCollect() {
            this.$refs.CollectionBoxRef.cancelHandler()
        }
    },
    mounted() {

    }
}
